import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ReportDailyVehicle from './report-daily-vehicle';
import ReportDailyVehicleDetail from './report-daily-vehicle-detail';
import ReportDailyVehicleUpdate from './report-daily-vehicle-update';
import ReportDailyVehicleDeleteDialog from './report-daily-vehicle-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ReportDailyVehicleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ReportDailyVehicleUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ReportDailyVehicleDetail} />
      <ErrorBoundaryRoute path={match.url} component={ReportDailyVehicle} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ReportDailyVehicleDeleteDialog} />
  </>
);

export default Routes;
